export const SET_SNACKBAR = 'SET_SNACKBAR';

export function setSnackbar(payload) {
  return {
    type: SET_SNACKBAR,
    payload: {
      message: payload
    }
  }
}